import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './AnnouncementBanner.module.css';

// The banner hides itself automatically from this date onwards (Oslo time),
// when order processing resumes after the summer holidays.
const ANNOUNCEMENT_END_DATE = new Date('2026-08-04T00:00:00+02:00');

// SearchPage keeps its Topbar fixed on desktop and offsets content by a fixed
// height, so a banner inside the Topbar would cover the results there.
const disabledPages = ['SearchPage', 'SearchPageWithListingType'];

/**
 * A friendly site-wide announcement banner shown at the top of the page.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.currentPage skip rendering on pages listed in disabledPages
 * @returns {JSX.Element?} AnnouncementBanner component
 */
const AnnouncementBanner = props => {
  const { rootClassName, className, currentPage } = props;
  const classes = classNames(rootClassName || css.root, className);

  const isExpired = new Date() >= ANNOUNCEMENT_END_DATE;
  const isDisabledPage = disabledPages.includes(currentPage);

  return isExpired || isDisabledPage ? null : (
    <div className={classes} role="status">
      <p className={css.text}>
        <FormattedMessage id="AnnouncementBanner.message" />
      </p>
    </div>
  );
};

export default AnnouncementBanner;
